// extracted by mini-css-extract-plugin
module.exports = {"container":"releasePage_container__7uuGv","contentTitle":"releasePage_contentTitle__ukQ1Q","content":"releasePage_content__7UGqy","list":"releasePage_list__f2Ysp"};